<template>
  <div>
    <v-container>
      <v-row no-gutters>
        <v-col cols="12" md="12">
          <v-card>
            <div>
              <v-btn small class="ma-2" @click="periodEdit()" fab color="warning">
                <v-icon>mdi-pencil</v-icon>
              </v-btn>
            </div>
            <v-simple-table>
              <tbody>
                <tr>
                  <td>ครั้งที่</td>
                  <td class="text-center font-weight-bold">{{ periods.period_times }}</td>
                  <td>ปี</td>
                  <td class="text-center font-weight-bold">{{ periods.period_year }}</td>
                </tr>
                <tr>
                  <td>เริ่มวันที่</td>
                  <td class="text-center font-weight-bold">
                    {{ periods.period_start | moment("add", "543 years") | moment("D MMMM YYYY") }}
                  </td>
                  <td>สิ้นสุดวันที่ (ยื่นย้าย)</td>
                  <td class="text-center font-weight-bold">
                    {{ periods.period_stop | moment("add", "543 years") | moment("D MMMM YYYY") }}
                  </td>
                </tr>

                <!-- ═══ แถวใหม่: วันสิ้นสุดแนบไฟล์ ═══ -->
                <tr>
                  <td>
                    <v-icon small color="primary" class="mr-1">mdi-paperclip</v-icon>
                    วันสุดท้ายแนบไฟล์
                  </td>
                  <td class="text-center font-weight-bold">
                    <span v-if="periods.period_stop_file">
                      {{ periods.period_stop_file | moment("add", "543 years") | moment("D MMMM YYYY") }}
                      <v-chip
                        x-small
                        :color="isFileWindowOpen ? 'success' : 'error'"
                        dark
                        class="ml-1"
                      >
                        {{ isFileWindowOpen ? "ยังแนบได้" : "ปิดแล้ว" }}
                      </v-chip>
                    </span>
                    <v-chip x-small color="grey" dark v-else>ใช้วันเดียวกับยื่นย้าย</v-chip>
                  </td>
                  <td>วันที่สิ้นสุดการนับ</td>
                  <td class="text-center font-weight-bold">
                    {{ periods.period_cal_end | moment("add", "543 years") | moment("D MMMM YYYY") }}
                  </td>
                </tr>

                <tr>
                  <td>อายุงาน</td>
                  <td class="text-center font-weight-bold">{{ periods.period_ageTime }}</td>
                  <td>กรณีปกติ</td>
                  <td class="text-center font-weight-bold">
                    <v-chip color="success" dark v-if="periods.period_normal_case == '1'">เปิด</v-chip>
                    <v-chip color="error"   dark v-else-if="periods.period_normal_case == '0'">ปิด</v-chip>
                  </td>
                </tr>

                <tr>
                  <td>กรณีพิเศษ/คุณภาพ</td>
                  <td class="text-center font-weight-bold">
                    <v-chip color="success" dark v-if="periods.period_quality_case == '1'">เปิด</v-chip>
                    <v-chip color="error"   dark v-else-if="periods.period_quality_case == '0'">ปิด</v-chip>
                  </td>
                  <td>สถานะระบบ (ยื่นย้าย)</td>
                  <td class="text-center font-weight-bold">
                    <v-chip color="success" dark v-if="periods.period_enable == '1'">เปิด</v-chip>
                    <v-chip color="error"   dark v-else-if="periods.period_enable == '0'">ปิด</v-chip>
                  </td>
                </tr>

                <tr>
                  <td>สถานะประมวลผล</td>
                  <td class="text-center font-weight-bold">
                    <v-chip color="success" dark v-if="periods.period_enable_process == '1'">เปิด</v-chip>
                    <v-chip color="error"   dark v-else-if="periods.period_enable_process == '0'">ปิด</v-chip>
                  </td>
                  <td colspan="2"></td>
                </tr>

                <!-- ═══ แถวสรุปสถานะระบบ 3 ระดับ ═══ -->
                <tr class="grey lighten-4">
                  <td colspan="4">
                    <div class="d-flex align-center flex-wrap pa-1" style="gap:8px">
                      <span class="font-weight-bold mr-2">สถานะปัจจุบัน:</span>

                      <v-chip
                        small
                        :color="periods.period_enable == '1' ? 'success' : 'info'"
                        dark
                      >
                        <v-icon left small>mdi-file-send</v-icon>
                        ยื่นย้าย: {{ periods.period_enable == '1' ? 'เปิด' : 'ปิด' }}
                      </v-chip>

                      <v-chip small :color="isFileWindowOpen ? 'primary' : 'info'" dark>
                        <v-icon left small>mdi-paperclip</v-icon>
                        แนบไฟล์: {{ isFileWindowOpen ? 'เปิด' : 'ปิด' }}
                      </v-chip>

                      <v-chip small color="info" dark>
                        <v-icon left small>mdi-printer</v-icon>
                        พิมพ์แบบคำร้อง: เปิดเสมอ
                      </v-chip>
                    </div>
                  </td>
                </tr>
              </tbody>
            </v-simple-table>
          </v-card>
        </v-col>
      </v-row>

      <!-- ═══════════════════════════════════════════════
           Dialog: แก้ไขกำหนดการ
           ═══════════════════════════════════════════════ -->
      <v-layout row justify-center>
        <v-dialog v-model="editperioddialog" persistent max-width="700px">
          <v-card class="mx-auto pa-6">
            <base-material-card
              color="warning"
              icon="mdi-clipboard-text"
              title="แก้ไขกำหนดการ"
              class="px-5 py-3 text_google"
            ></base-material-card>

            <v-card-text>
              <v-form ref="editperiodform" lazy-validation>
                <v-container grid-list-md>
                  <v-layout wrap>

                    <!-- ── ปีและครั้งที่ ── -->
                    <v-flex xs12 md6>
                      <v-select
                        v-model="editperiod.period_year"
                        :items="periodselect"
                        item-text="text"
                        item-value="value"
                        label="เลือกปีการศึกษา"
                        rounded outlined
                      ></v-select>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-text-field
                        type="number"
                        label="ครั้งที่"
                        v-model="editperiod.period_times"
                        :rules="[v => !!v || '']"
                        rounded outlined
                      ></v-text-field>
                    </v-flex>

                    <!-- ── วันที่ยื่นย้าย ── -->
                    <v-flex xs12>
                      <div class="subtitle-2 mb-1">
                        <v-icon small color="primary" class="mr-1">mdi-file-send</v-icon>
                        <strong>ช่วงเวลายื่นย้าย</strong>
                      </div>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-text-field
                        type="date"
                        label="วันที่เริ่ม"
                        v-model="editperiod.period_start"
                        :rules="[v => !!v || '']"
                        rounded outlined
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-text-field
                        type="date"
                        label="วันที่สิ้นสุด (ปิดรับการยื่นย้าย)"
                        v-model="editperiod.period_stop"
                        :rules="[v => !!v || '']"
                        rounded outlined
                        hint="หลังวันนี้จะไม่สามารถยื่นหรือยกเลิกรายการได้"
                        persistent-hint
                      ></v-text-field>
                    </v-flex>

                    <!-- ── วันสุดท้ายแนบไฟล์ ★ ใหม่ ★ ── -->
                    <v-flex xs12>
                      <div class="subtitle-2 mb-1 mt-2">
                        <v-icon small color="primary" class="mr-1">mdi-paperclip</v-icon>
                        <strong class="primary--text">วันสุดท้ายที่อนุญาตให้แนบไฟล์แบบคำร้อง</strong>
                      </div>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-text-field
                        type="date"
                        label="วันสุดท้ายแนบไฟล์"
                        v-model="editperiod.period_stop_file"
                        rounded outlined
                        clearable
                        prepend-icon="mdi-paperclip"
                        hint="ปล่อยว่างไว้ = ใช้วันเดียวกับวันสิ้นสุดยื่นย้าย"
                        persistent-hint
                        :rules="[validateFileStopDate]"
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6 class="d-flex align-center">
                      <v-alert dense outlined type="info" class="ma-0 body-2">
                        <p class="mb-1"><strong>ตัวอย่างการใช้งาน:</strong></p>
                        <p class="mb-0">ปิดยื่นย้าย: <strong>{{ editperiod.period_stop || '-' }}</strong></p>
                        <p class="mb-0">แนบไฟล์ได้ถึง: <strong>{{ editperiod.period_stop_file || editperiod.period_stop || '-' }}</strong></p>
                        <p class="mb-0 mt-1 success--text" v-if="fileWindowDays > 0">
                          <v-icon small color="success">mdi-check</v-icon>
                          เปิดแนบไฟล์เพิ่ม {{ fileWindowDays }} วัน หลังปิดยื่นย้าย
                        </p>
                        <p class="mb-0 mt-1 grey--text" v-else-if="fileWindowDays === 0">
                          แนบไฟล์ได้ถึงวันเดียวกับวันปิดยื่นย้าย
                        </p>
                      </v-alert>
                    </v-flex>

                    <!-- ── วันที่สิ้นสุดการนับ ── -->
                    <v-flex xs12>
                      <div class="subtitle-2 mb-1 mt-2">
                        <v-icon small color="grey darken-1" class="mr-1">mdi-calculator</v-icon>
                        <strong>การคำนวณ</strong>
                      </div>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-text-field
                        type="date"
                        label="วันที่สิ้นสุดการนับถึง"
                        v-model="editperiod.period_cal_end"
                        :rules="[v => !!v || '']"
                        rounded outlined
                      ></v-text-field>
                    </v-flex>
                    <v-flex xs12 md6>
                      <v-text-field
                        type="number"
                        label="อายุงานที่ใช้ในการคำนวณ"
                        v-model="editperiod.period_ageTime"
                        :rules="[v => !!v || '']"
                        rounded outlined
                      ></v-text-field>
                    </v-flex>

                    <!-- ── สวิตช์เปิด/ปิด ── -->
                    <v-flex xs12>
                      <v-divider class="my-3"></v-divider>
                      <div class="subtitle-2 mb-2">
                        <v-icon small class="mr-1">mdi-toggle-switch</v-icon>
                        <strong>สวิตช์เปิด/ปิดระบบ</strong>
                      </div>
                    </v-flex>

                    <v-flex xs12 md6>
                      เปิด/ปิด <span class="font-weight-bold">ระบบสำหรับบุคคล</span> (ยื่นย้าย):
                      <v-switch v-model="editperiod.period_enable_sw" label="เปิดใช้ระบบ"></v-switch>
                    </v-flex>
                    <v-flex xs12 md6>
                      เปิด/ปิด <span class="font-weight-bold">ระบบสำหรับผู้ดูแล</span>:
                      <v-switch v-model="editperiod.period_enable_sw_process" label="เปิดใช้ระบบประมวลผล"></v-switch>
                    </v-flex>

                    <v-flex xs12 md6>
                      เปิด/ปิด <span class="font-weight-bold success--text">กรณีปกติ</span>:
                      <v-switch v-model="editperiod.period_normal_case_sw" label="เปิดใช้ระบบ"></v-switch>
                    </v-flex>
                    <v-flex xs12 md6>
                      เปิด/ปิด <span class="font-weight-bold info--text">กรณีพิเศษ/คุณภาพ</span>:
                      <v-switch v-model="editperiod.period_quality_case_sw" label="เปิดใช้ระบบประมวลผล"></v-switch>
                    </v-flex>

                  </v-layout>
                </v-container>
                <small>* จำเป็น</small>
              </v-form>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn large rounded @click.stop="editperioddialog = false">
                <v-icon dark>mdi-close</v-icon> ยกเลิก
              </v-btn>
              <v-btn large color="warning" rounded @click.stop="editperiodSubmit()">
                <v-icon dark>mdi-pencil</v-icon> บันทึก
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </v-layout>
    </v-container>

    <!-- Snackbar -->
    <v-container fluid>
      <v-snackbar
        v-model="snackbar.show"
        multi-line vertical top
        :timeout="snackbar.timeout"
        :color="snackbar.color"
      >
        <v-icon large>{{ snackbar.icon }}</v-icon><br />
        {{ snackbar.text }}
        <v-btn dark @click="snackbar.show = false">Close</v-btn>
      </v-snackbar>
    </v-container>
  </div>
</template>

<script>
import VueMoment from "vue-moment";
import moment from "moment-timezone";

export default {
  data() {
    return {
      VueMoment,
      moment,
      loading: true,
      ApiKey: "HRvec2021",
      valid: true,
      editperioddialog: false,
      snackbar: { show: false, color: "", timeout: 5000, icon: "", text: "" },
      periods: {},
      editperiod: {},
      periodselect: [
        { value: "2564", text: "2564" },
        { value: "2565", text: "2565" },
        { value: "2566", text: "2566" },
        { value: "2567", text: "2567" },
        { value: "2568", text: "2568" },
        { value: "2569", text: "2569" },
        { value: "2570", text: "2570" }
      ],
      data_syslog: {}
    };
  },

  async mounted() {
    this.periodQueryAll();
  },

  computed: {
    /** วันสุดท้ายแนบไฟล์ยังไม่ผ่านไปหรือยัง */
    isFileWindowOpen() {
      const stopRaw = this.periods.period_stop_file || this.periods.period_stop;
      if (!stopRaw) return false;
      const today    = new Date();
      today.setHours(0, 0, 0, 0);
      const stopDate = new Date(stopRaw);
      return today <= stopDate;
    },

    /** จำนวนวันที่เปิดแนบไฟล์เพิ่มหลังปิดยื่นย้าย (ใช้ใน hint) */
    fileWindowDays() {
      const stop     = this.editperiod.period_stop;
      const stopFile = this.editperiod.period_stop_file;
      if (!stop || !stopFile) return 0;
      const d1 = new Date(stop);
      const d2 = new Date(stopFile);
      return Math.round((d2 - d1) / (1000 * 60 * 60 * 24));
    },

    date_today_log() {
      const today = new Date();
      const dd  = String(today.getDate()).padStart(2, "0");
      const mm  = String(today.getMonth() + 1).padStart(2, "0");
      const yy  = today.getFullYear() + 543;
      const time = today.getHours() + ":" + today.getMinutes() + ":" + today.getSeconds();
      return `${dd}/${mm}/${yy}/${time}`;
    }
  },

  methods: {
    // ── โหลดข้อมูล ─────────────────────────────────────────────────────
    async periodQueryAll() {
      this.loading = true;
      const r = await this.$http
        .post("period.php", { ApiKey: this.ApiKey, period_id: "201" })
        .finally(() => (this.loading = false));
      this.periods = r.data;
    },

    // ── เปิด Dialog แก้ไข ──────────────────────────────────────────────
    async periodEdit() {
      const r = await this.$http.post("period.php", {
        ApiKey: this.ApiKey,
        period_id: "201"
      });
      this.editperiod = { ...r.data };

      // แปลงค่าตัวเลข/string → boolean สำหรับ v-switch
      this.editperiod.period_enable_sw          = this.editperiod.period_enable         == "1";
      this.editperiod.period_enable_sw_process  = this.editperiod.period_enable_process == "1";
      this.editperiod.period_normal_case_sw     = this.editperiod.period_normal_case    == "1";
      this.editperiod.period_quality_case_sw    = this.editperiod.period_quality_case   == "1";

      // ถ้า period_stop_file เป็น null/empty ให้ใช้ค่า period_stop เป็น default
      if (!this.editperiod.period_stop_file) {
        this.editperiod.period_stop_file = this.editperiod.period_stop || "";
      }

      this.editperioddialog = true;
    },

    // ── Validate: วันแนบไฟล์ต้องไม่ก่อนวันปิดยื่นย้าย ────────────────
    validateFileStopDate(v) {
      if (!v || !this.editperiod.period_stop) return true;
      return new Date(v) >= new Date(this.editperiod.period_stop)
        || "วันสุดท้ายแนบไฟล์ต้องไม่ก่อนวันปิดยื่นย้าย";
    },

    // ── บันทึก ──────────────────────────────────────────────────────────
    async editperiodSubmit() {
      if (!this.$refs.editperiodform.validate()) return;

      // แปลง boolean → "1"/"0"
      this.editperiod.period_enable         = this.editperiod.period_enable_sw         ? "1" : "0";
      this.editperiod.period_enable_process = this.editperiod.period_enable_sw_process ? "1" : "0";
      this.editperiod.period_normal_case    = this.editperiod.period_normal_case_sw    ? "1" : "0";
      this.editperiod.period_quality_case   = this.editperiod.period_quality_case_sw   ? "1" : "0";

      // ถ้าลบค่า period_stop_file ออก (clearable) ให้ส่ง null
      if (!this.editperiod.period_stop_file) {
        this.editperiod.period_stop_file = null;
      }

      this.editperiod.ApiKey = this.ApiKey;

      const result = await this.$http.post("period.update.php", this.editperiod);
      if (result.data.status == true) {
        Swal.fire({
          icon: "success",
          title: "แก้ไขข้อมูลเรียบร้อย",
          showConfirmButton: false,
          timer: 1500
        });
        this.periodQueryAll();

        // บันทึก syslog
        const us = JSON.parse(localStorage.getItem("user")) || {};
        this.data_syslog.ApiKey       = this.ApiKey;
        this.data_syslog.user_account = us.user_name;
        this.data_syslog.event_log    = "update";
        this.data_syslog.page_log     = "period";
        this.data_syslog.table_log    = "period";
        this.data_syslog.date_times   = this.date_today_log;
        await this.$http.post("data_syslog.insert.php", this.data_syslog);
      } else {
        Swal.fire({
          icon: "warning",
          title: "แก้ไขข้อมูลผิดพลาด",
          showConfirmButton: false,
          timer: 1500
        });
      }
      this.editperioddialog = false;
    }
  }
};
</script>